import { getCurrentInstance } from 'vue';

export default function useI18n(): {translate: (str: string, values?: any) => string;} {
  const instance = getCurrentInstance();
  return {
    translate(str: string, values?: any): string {
      const i18n: any = (this as any)?.$i18n || ((instance?.root as any).ctx?.$i18n);
      return i18n.t(str, values) as string;
    },
  };
}

export interface TranslateFn {
  (str: string, values?: any): string;
}
